
import Vue from 'vue';
import { settingsHelper } from '@/store/modules/settings';
const settingsHelpers = settingsHelper.mapGetters(['brand']);
export default Vue.extend({
  name: 'CompanyBrand',
  computed: {
    ...settingsHelpers,
  },
});
